var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav_tab i_mlr_6 i_mlr_md_4 i_mlr_sm_2 flex-shrink-0 flex-shrink-md-1 flex-grow-0",class:{ selected: _vm.selected }},[_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }